module.exports = __webpack_public_path__ + "img/xray2.d368234f.png";